/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuoteRestrictionType {
  PickupOpenBefore = "pickup_open_before",
  DeliveryCloseAfter = "delivery_close_after",
  MinTransitWindowHours = "min_transit_window_hours",
}

export function instanceOfQuoteRestrictionType(value: any): boolean {
  for (const key in QuoteRestrictionType) {
    if (Object.prototype.hasOwnProperty.call(QuoteRestrictionType, key)) {
      if (
        QuoteRestrictionType[key as keyof typeof QuoteRestrictionType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuoteRestrictionTypeFromJSON(json: any): QuoteRestrictionType {
  return QuoteRestrictionTypeFromJSONTyped(json, false);
}

export function QuoteRestrictionTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteRestrictionType {
  return json as QuoteRestrictionType;
}

export function QuoteRestrictionTypeToJSON(
  value?: QuoteRestrictionType | null,
): any {
  return value as any;
}

export function QuoteRestrictionTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuoteRestrictionType {
  return value as QuoteRestrictionType;
}
